// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Notification_notification__189UW {
    display: flex;
    background: var(--color-darkui-surface-4);
    color: var(--color-106);
    border-radius: 8px;
    box-shadow: 0 0 0 1px rgba(255,255,255,0.2);
    font-size: 14px;
    width: fit-content;
    max-width: 600px;
}

.Notification_msgText__MwYge {
    padding: 14px 20px;
    flex-grow: 1;
    line-height: 1.6;
}

.Notification_close__7IihH {
    background: transparent;
    border:none;
    color: var(--color-106);
    font-size: 20px;
    padding: 0;
    margin: 0;
    height: 50px;
    width: 50px;
    line-height: 50px;
    cursor: pointer;
    flex-shrink: 0;
  }`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Notification/Notification.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yCAAyC;IACzC,uBAAuB;IACvB,kBAAkB;IAClB,2CAA2C;IAC3C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,SAAS;IACT,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB","sourcesContent":[".notification {\n    display: flex;\n    background: var(--color-darkui-surface-4);\n    color: var(--color-106);\n    border-radius: 8px;\n    box-shadow: 0 0 0 1px rgba(255,255,255,0.2);\n    font-size: 14px;\n    width: fit-content;\n    max-width: 600px;\n}\n\n.msgText {\n    padding: 14px 20px;\n    flex-grow: 1;\n    line-height: 1.6;\n}\n\n.close {\n    background: transparent;\n    border:none;\n    color: var(--color-106);\n    font-size: 20px;\n    padding: 0;\n    margin: 0;\n    height: 50px;\n    width: 50px;\n    line-height: 50px;\n    cursor: pointer;\n    flex-shrink: 0;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notification": `Notification_notification__189UW`,
	"msgText": `Notification_msgText__MwYge`,
	"close": `Notification_close__7IihH`
};
export default ___CSS_LOADER_EXPORT___;
